import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import LinkOnly from './LinkOnly';
import './Style.scss'

export class TextOverImage extends Component {
  
    render() {
        var content = this.props.articleObj;
        return (
            <>
              <div className={`banner-image my-2 ${content.attributes.articleRendering}  ${content.attributes.class}`}>
                    <Link to={content.attributes.linkUrl}><img fetchpriority="high" src={content.mainImage ? content.mainImage : ""} /></Link>
                    <div className="banner-text mobile-banner-text" dangerouslySetInnerHTML={{ __html: content.title }}></div>
                    <div className="banner-text-1 mobile-banner-text-1" dangerouslySetInnerHTML={{ __html: content.body }}></div>
                    {content.attributes.linkName ? <LinkOnly articleObj={content} /> : ""}
                </div>
            </> 
        )
    }
    
}

export default TextOverImage
